(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/collections/favoriteteamlist.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/collections/favoriteteamlist.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport = svs.sport || {};
  svs.sport.favorites = svs.sport.favorites || {};
  svs.sport.favorites.collections = svs.sport.favorites.collections || {};

  svs.sport.favorites.collections.FavoriteTeamList = Backbone.Collection.extend(
    {
      initialize: function() {},
      toSaveData: function() {
        var saveData = [];
        this.models = _.sortBy(this.models, function(team) {
          return team.get('TeamName');
        });
        this.each(function(team) {
          var teamId = team.get('TeamId');
          if (teamId) {
            saveData.push(teamId);
          }
        });
        return saveData;
      },
      moveUp: function(model) {
        var index = this.indexOf(model);
        if (index > 0) {
          this.remove(model); 
          this.add(model, { at: index - 1 });
          return true;
        }
        return false;
      },
      moveDown: function(model) {
        var index = this.indexOf(model);
        if (index < this.length - 1) {
          this.remove(model, { silent: true }); 
          this.add(model, { at: index + 1 });
          return true;
        }
        return false;
      },
      modify: function(data) {
        var model = this.findWhere({ TeamId: data.model.get('id') });
        if (model !== undefined) {
          this.remove(model);
        } else {
          this.add(
            new this.model({
              TeamId: data.model.get('id'),
              TeamName: data.model.get('name')
            })
          );
        }
      }
    }
  );
})(this.Backbone, this._, this.svs);

 })(window);